import { AnimatedHeight } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import Icon from 'components/priority/Icon/Icon'
import * as S from './CustomizeTabs.styled'
import findIndex from 'lodash/findIndex'

export const CustomizeTabs = ({
  tabs,
  width,
  noOverflow,
  icon,
  iconClick,
  selected: [selected, setSelected] = ['', () => {}],
}) => {
  const selectedIndex = findIndex(tabs, ({ title }) => title === selected)

  const iconClickUnpropagated = (e, i) => {
    e.stopPropagation()
    iconClick(tabs[i])
  }

  return (
    <Flex full overflow="hidden">
      <S.TabScrollContainer column margin="0 42px" width={width} height="550px">
        {tabs?.map(({ title, thumbnail }, i) => (
          <S.Tab
            clickable
            key={`${title}${i}`}
            padding="16px"
            radius="2px"
            align="center"
            justify={icon ? 'space-between' : undefined}
            margin={
              title.includes('Front Insert') || title.includes('Extra')
                ? '0 0 0 25px'
                : undefined
            }
            selected={selectedIndex === i}
            onClick={() => setSelected(title)}
          >
            <S.Thumbnail
              width="40px"
              height="40px"
              margin="0 16px 0 0"
              thumbnail={thumbnail}
            />
            <Text>{title}</Text>
            {icon && (
              <Icon
                icon={icon}
                fill="gray2"
                onClick={(e) => iconClickUnpropagated(e, i)}
              />
            )}
          </S.Tab>
        ))}
      </S.TabScrollContainer>
      <Flex
        align="flex-start"
        column
        flex="1"
        overflow={!noOverflow ? 'auto' : 'inherit'}
      >
        {tabs?.map(({ title, content }, i) => (
          <AnimatedHeight
            key={`${title}${i}`}
            height={selectedIndex === i ? 'auto' : 0}
            duration={250}
          >
            {selectedIndex === i && content}
          </AnimatedHeight>
        ))}
      </Flex>
    </Flex>
  )
}

export default CustomizeTabs
